<template>
  <div class="content container-fluid">
    <breadcrumb-index :items="breadcrumbs" />

    <div class="card">
      <div class="card-header">
        <h5 class="card-title mb-0">Add Syllabus</h5>
      </div>
      <div class="card-body">
        <form @submit.prevent="handleSubmit">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">Title <span class="text-danger">*</span></label>
              <input v-model="form.title" type="text" class="form-control" required />
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Course <span class="text-danger">*</span></label>
              <select v-model="form.courseId" class="form-select" required>
                <option value="">Select Course</option>
                <option v-for="course in courses" :key="course.id" :value="course.id">{{ course.name }}</option>
              </select>
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label">Description</label>
            <textarea v-model="form.description" class="form-control" rows="2"></textarea>
          </div>

          <div class="mb-3">
            <label class="form-label">Topics</label>
            <div v-for="(topic, index) in form.topics" :key="index" class="input-group mb-2">
              <span class="input-group-text">{{ index + 1 }}</span>
              <input v-model="topic.title" type="text" class="form-control" placeholder="Topic title" />
              <button type="button" class="btn btn-outline-danger" @click="removeTopic(index)" v-if="form.topics.length > 1">
                <vue-feather type="x" size="14" />
              </button>
            </div>
            <button type="button" class="btn btn-outline-secondary btn-sm" @click="addTopic">
              <vue-feather type="plus" size="14" class="me-1" />
              Add Topic
            </button>
          </div>

          <div class="mb-3">
            <label class="form-label">Status</label>
            <select v-model="form.status" class="form-select">
              <option value="draft">Draft</option>
              <option value="published">Published</option>
            </select>
          </div>

          <div v-if="error" class="alert alert-danger">{{ error }}</div>

          <div class="d-flex gap-2">
            <button type="submit" class="btn btn-primary" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
              Create Syllabus
            </button>
            <router-link to="/app/syllabus/list" class="btn btn-secondary">Cancel</router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import api from '@/services/api'
import { useAlert } from '@/plugins/sweetalert'

export default {
  name: 'AddSyllabus',
  setup() {
    const router = useRouter()
    const alert = useAlert()
    const breadcrumbs = [
      { title: 'Dashboard', url: '/app/dashboard' },
      { title: 'Syllabus', url: '/app/syllabus/list' },
      { title: 'Add Syllabus', active: true }
    ]

    const form = ref({ title: '', courseId: '', description: '', status: 'draft', topics: [{ title: '' }] })
    const courses = ref([])
    const loading = ref(false)
    const error = ref('')

    const fetchCourses = async () => {
      try {
        const response = await api.get('/v1/admin/courses')
        courses.value = response.data.courses
      } catch (err) {
        console.error('Failed to fetch courses:', err)
      }
    }

    const addTopic = () => form.value.topics.push({ title: '' })
    const removeTopic = (index) => form.value.topics.splice(index, 1)

    const handleSubmit = async () => {
      loading.value = true
      error.value = ''

      try {
        await api.post('/v1/admin/syllabus', form.value)
        alert.success('Success', 'Syllabus created successfully')
        router.push('/app/syllabus/list')
      } catch (err) {
        error.value = err.response?.data?.message || 'Failed to create syllabus'
      } finally {
        loading.value = false
      }
    }

    onMounted(fetchCourses)

    return { breadcrumbs, form, courses, loading, error, addTopic, removeTopic, handleSubmit }
  }
}
</script>
